// import React, { useState, useEffect } from 'react';
// import { useTranslation } from 'react-i18next';
// import api from '../../services/api';

// const ReviewPage = ({ onButtonClick, onBack, user }) => {
//   const { t } = useTranslation();
//   const [reviewType, setReviewType] = useState('services');
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [detailedReview, setDetailedReview] = useState({
//     rating: 0,
//     selectedAspects: [],
//     comment: ''
//   });
//   const [doctors, setDoctors] = useState([]);
//   const [services, setServices] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [submitting, setSubmitting] = useState(false);

//   const aspects = [
//     { id: 'quality', name: t('reviewPage.aspects.quality'), icon: "/icons/quality.png" },
//     { id: 'speed', name: t('reviewPage.aspects.speed'), icon: "/icons/speed.png" },
//     { id: 'cleanliness', name: t('reviewPage.aspects.cleanliness'), icon: "/icons/clean.png" },
//     { id: 'politeness', name: t('reviewPage.aspects.politeness'), icon: "/icons/politeness.png" },
//     { id: 'waitingTime', name: t('reviewPage.aspects.waitingTime'), icon: "/icons/waiting.png" },
//     { id: 'value', name: t('reviewPage.aspects.value'), icon: "/icons/value.png" }
//   ];

//   const ratings = [1, 2, 3, 4, 5];

//   // Загружаем врачей из бэкенда
//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const doctorsData = await api.getDoctors();
//         setDoctors(doctorsData);
        
//         // Загружаем уникальные услуги для отзывов (основные категории)
//         const allServices = await api.getServices();
//         const uniqueCategories = [];
//         const categoryMap = new Map();
        
//         allServices.forEach(service => {
//           if (!categoryMap.has(service.category_name)) {
//             categoryMap.set(service.category_name, {
//               id: service.category_id,
//               name: service.category_name,
//               icon: getIconForCategory(service.category_name)
//             });
//             uniqueCategories.push({
//               id: service.category_id,
//               name: service.category_name,
//               icon: getIconForCategory(service.category_name)
//             });
//           }
//         });
        
//         setServices(uniqueCategories);
//       } catch (error) {
//         console.error('Ошибка загрузки данных:', error);
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     fetchData();
//   }, []);

//   // Функция для иконки категории
//   const getIconForCategory = (categoryName) => {
//     const icons = {
//       'Лучевая диагностика': '/icons/phototherapy.png',
//       'Лабораторная диагностика': '/icons/lab.png',
//       'Check-up': '/icons/checkup.png',
//       'Функциональная диагностика': '/icons/functional.png',
//       'Дополнительно к медосмотру': '/icons/doctors.png'
//     };
//     return icons[categoryName] || '/icons/default.png';
//   };

//   const handleRateDoctor = (doctor) => {
//     setSelectedCategory({ type: 'doctor', data: doctor });
//     setDetailedReview({
//       rating: 0,
//       selectedAspects: [],
//       comment: ''
//     });
//   };

//   const handleRateService = (service) => {
//     setSelectedCategory({ type: 'service', data: service });
//     setDetailedReview({
//       rating: 0,
//       selectedAspects: [],
//       comment: ''
//     });
//   };

//   const handleRatingSelect = (rating) => {
//     setDetailedReview(prev => ({ ...prev, rating }));
//   };

//   const handleAspectToggle = (aspectId) => {
//     setDetailedReview(prev => {
//       const isSelected = prev.selectedAspects.includes(aspectId);
//       if (isSelected) {
//         return {
//           ...prev,
//           selectedAspects: prev.selectedAspects.filter(id => id !== aspectId)
//         };
//       } else {
//         return {
//           ...prev,
//           selectedAspects: [...prev.selectedAspects, aspectId]
//         };
//       }
//     });
//   };

//   const handleCommentChange = (e) => {
//     setDetailedReview(prev => ({ ...prev, comment: e.target.value }));
//   };

//   const handleSubmitReview = async () => {
//     if (detailedReview.rating === 0) {
//       alert(t('reviewPage.alerts.ratingRequired'));
//       return;
//     }
    
//     if (!user?.id) {
//       alert('Для отправки отзыва необходимо авторизоваться');
//       return;
//     }
    
//     setSubmitting(true);
    
//     try {
//       const reviewData = {
//         user_id: user.id,
//         rating: detailedReview.rating,
//         comment: detailedReview.comment || ''
//       };
      
//       if (selectedCategory.type === 'doctor') {
//         reviewData.doctor_id = selectedCategory.data.id;
//       } else {
//         reviewData.service_id = selectedCategory.data.id;
//       }
      
//       const result = await api.addReview(reviewData);
      
//       if (result) {
//         alert('Спасибо за отзыв! Он будет опубликован после модерации.');
//         setSelectedCategory(null);
//         setDetailedReview({
//           rating: 0,
//           selectedAspects: [],
//           comment: ''
//         });
//       } else {
//         alert('Произошла ошибка при отправке отзыва');
//       }
//     } catch (error) {
//       console.error('Ошибка отправки отзыва:', error);
//       alert('Произошла ошибка при отправке отзыва');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleCloseModal = () => {
//     setSelectedCategory(null);
//     setDetailedReview({
//       rating: 0,
//       selectedAspects: [],
//       comment: ''
//     });
//   };

//   if (loading) {
//     return (
//       <div className="review-page">
//         <div className="review-header">
//           <button className="service-btn back-btn" onClick={onBack}>
//             <span className="btn-icon">←</span>
//             <span className="btn-text">{t('reviewPage.back')}</span>
//           </button>
//         </div>
//         <div className="loading-spinner" style={{ textAlign: 'center', padding: '40px', color: 'white' }}>
//           Загрузка...
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="review-page">
//       <div className="review-header">
//         <button className="service-btn back-btn" onClick={onBack}>
//           <span className="btn-icon">←</span>
//           <span className="btn-text">{t('reviewPage.back')}</span>
//         </button>
//       </div>

//       <div className="rating-header">
//         <h2>{t('reviewPage.title')}</h2>
//         <p>{t('reviewPage.subtitle')}</p>
//       </div>

//       <div className="review-switcher">
//         <button 
//           className={`switcher-btn ${reviewType === 'services' ? 'active' : ''}`}
//           onClick={() => setReviewType('services')}
//         >
//           <span className="switcher-text">{t('reviewPage.switcher.services')}</span>
//         </button>
        
//         <button 
//           className={`switcher-btn ${reviewType === 'doctors' ? 'active' : ''}`}
//           onClick={() => setReviewType('doctors')}
//         >
//           <span className="switcher-text">{t('reviewPage.switcher.doctors')}</span>
//         </button>
//       </div>

//       {selectedCategory && (
//         <div className="detailed-rating-modal">
//           <div className="detailed-modal-content">
//             <div className="detailed-modal-header">
//               <div className="modal-category">
//                 <div className="modal-icon">
//                   {selectedCategory.type === 'doctor' 
//                     ? <img src={selectedCategory.data.image_url} alt={selectedCategory.data.name} className="doctor-photo-img" onError={(e) => { e.target.src = '/icons/doctor-default.png'; }} />
//                     : <img src={selectedCategory.data.icon} alt={selectedCategory.data.name} width="40" height="40" />}
//                 </div>
//                 <div className="modal-title">
//                   <h3>
//                     {selectedCategory.type === 'doctor' 
//                       ? selectedCategory.data.specialty 
//                       : selectedCategory.data.name}
//                   </h3>
//                   <p className="modal-subtitle">
//                     {selectedCategory.type === 'doctor' 
//                       ? selectedCategory.data.name 
//                       : t('reviewPage.modal.leaveRating')}
//                   </p>
//                 </div>
//               </div>
//               <button className="modal-close-btn" onClick={handleCloseModal}>
//                 ✕
//               </button>
//             </div>

//             <div className="detailed-rating-section">
//               <h4>{t('reviewPage.modal.rateQuality')}</h4>
//               <div className="detailed-rating-stars">
//                 {ratings.map((rating) => (
//                   <button
//                     key={rating}
//                     className={`detailed-star-btn ${detailedReview.rating >= rating ? 'active' : ''}`}
//                     onClick={() => handleRatingSelect(rating)}
//                   >
//                     <span className="star-icon">★</span>
//                     <span className="star-number">{rating}</span>
//                   </button>
//                 ))}
//               </div>
//             </div>

//             <div className="aspects-section">
//               <h4>{t('reviewPage.modal.whatLiked')}</h4>
//               <div className="aspects-grid">
//                 {aspects.map((aspect) => (
//                   <button
//                     key={aspect.id}
//                     className={`aspect-btn ${detailedReview.selectedAspects.includes(aspect.id) ? 'selected' : ''}`}
//                     onClick={() => handleAspectToggle(aspect.id)}
//                   >
//                     <span className="aspect-icon">
//                       <img src={aspect.icon} alt={aspect.name} width="20" height="20" />
//                     </span>
//                     <span className="aspect-name">{aspect.name}</span>
//                   </button>
//                 ))}
//               </div>
//             </div>

//             <div className="comment-section">
//               <h4>{t('reviewPage.modal.shareExperience')}</h4>
//               <textarea
//                 className="comment-input"
//                 placeholder={t('reviewPage.modal.commentPlaceholder')}
//                 value={detailedReview.comment}
//                 onChange={handleCommentChange}
//                 maxLength={500}
//                 rows={4}
//               />
//               <div className="comment-counter">
//                 {detailedReview.comment.length}/500 {t('reviewPage.modal.characters')}
//               </div>
//             </div>

//             <div className="modal-actions">
//               <button 
//                 className={`submit-review-btn ${detailedReview.rating === 0 || submitting ? 'disabled' : ''}`}
//                 onClick={handleSubmitReview}
//                 disabled={detailedReview.rating === 0 || submitting}
//               >
//                 <span className="submit-text">{submitting ? 'Отправка...' : t('reviewPage.modal.submit')}</span>
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {reviewType === 'doctors' && !selectedCategory && (
//         <div className="doctors-list">
//           <div className="section-divider">
//             <h3>{t('reviewPage.doctorList.title')}</h3>
//           </div>
          
//           <div className="doctors-grid">
//             {doctors.map((doctor) => (
//               <div 
//                 key={doctor.id} 
//                 className="doctor-card"
//                 onClick={() => handleRateDoctor(doctor)}
//               >
//                 <div className="doctor-photo">
//                   <img 
//                     src={doctor.image_url} 
//                     alt={doctor.name} 
//                     className="doctor-photo-img" 
//                     onError={(e) => { e.target.src = '/icons/doctor-default.png'; }}
//                   />
//                 </div>
//                 <div className="doctor-info">
//                   <h4 className="doctor-specialty">{doctor.specialty}</h4>
//                   <p className="doctor-name">{doctor.name}</p>
//                   {doctor.rating > 0 && (
//                     <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '5px', justifyContent: 'center' }}>
//                       <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
//                         {Array(Math.floor(doctor.rating)).fill().map((_, i) => <span key={i}>⭐</span>)}
//                       </div>
//                       <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.6)' }}>
//                         ({doctor.reviews_count})
//                       </span>
//                     </div>
//                   )}
//                   <div className="rate-button">{t('reviewPage.doctorList.rateButton')}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {reviewType === 'services' && !selectedCategory && (
//         <div className="services-list">
//           <div className="section-divider">
//             <h3>{t('reviewPage.serviceList.title')}</h3>
//           </div>
          
//           <div className="services-grid">
//             {services.map((service) => (
//               <div 
//                 key={service.id} 
//                 className="service-card"
//                 onClick={() => handleRateService(service)}
//               >
//                 <div className="service-icon">
//                   <img src={service.icon} alt={service.name} width="40" height="40" />
//                 </div>
//                 <div className="service-info">
//                   <h4 className="service-name">{service.name}</h4>
//                   <div className="rate-button">{t('reviewPage.serviceList.rateButton')}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       <div className="review-footer">
//         <p className="review-note">
//           {t('reviewPage.footer.note')}
//         </p>
//       </div>
//     </div>
//   );
// };

// export default ReviewPage;





import React, { useState, useEffect } from 'react';
import { useTranslation} from 'react-i18next';
import api from '../../services/api';

const ReviewPage = ({ onButtonClick, onBack, user }) => {
  const { t } = useTranslation();
  const [reviewType, setReviewType] = useState('services');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [detailedReview, setDetailedReview] = useState({
    rating: 0,
    selectedAspects: [],
    comment: ''
  });
  const [doctors, setDoctors] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const aspects = [
    { id: 'quality', name: t('reviewPage.aspects.quality'), icon: "/icons/quality.png" },
    { id: 'speed', name: t('reviewPage.aspects.speed'), icon: "/icons/speed.png" },
    { id: 'cleanliness', name: t('reviewPage.aspects.cleanliness'), icon: "/icons/clean.png" },
    { id: 'politeness', name: t('reviewPage.aspects.politeness'), icon: "/icons/politeness.png" },
    { id: 'waitingTime', name: t('reviewPage.aspects.waitingTime'), icon: "/icons/waiting.png" },
    { id: 'value', name: t('reviewPage.aspects.value'), icon: "/icons/value.png" }
  ];

  const ratings = [1, 2, 3, 4, 5];

  // Загружаем врачей и категории
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const doctorsData = await api.getDoctors();
        setDoctors(doctorsData);
        
        const categoriesData = await api.getCategories();
        setCategories(categoriesData);
      } catch (error) {
        console.error('Ошибка загрузки данных:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, []);

  // Загружаем подкатегории при выборе категории
  const handleCategorySelect = async (category) => {
    setSelectedCategory(category);
    setSelectedSubcategory(null);
    setSelectedService(null);
    try {
      const subcategoriesData = await api.getSubcategories(category.id);
      setSubcategories(subcategoriesData);
    } catch (error) {
      console.error('Ошибка загрузки подкатегорий:', error);
      setSubcategories([]);
    }
  };

  // Загружаем услуги при выборе подкатегории
  const handleSubcategorySelect = async (subcategory) => {
    setSelectedSubcategory(subcategory);
    setSelectedService(null);
    try {
      const servicesData = await api.getServicesBySubcategory(subcategory.id);
      setServices(servicesData);
    } catch (error) {
      console.error('Ошибка загрузки услуг:', error);
      setServices([]);
    }
  };

  // Выбор конкретной услуги для оценки
  const handleServiceSelect = (service) => {
    setSelectedService(service);
    setDetailedReview({
      rating: 0,
      selectedAspects: [],
      comment: ''
    });
  };

  const handleRateDoctor = (doctor) => {
    setSelectedService({ type: 'doctor', data: doctor });
    setDetailedReview({
      rating: 0,
      selectedAspects: [],
      comment: ''
    });
  };

  const handleRatingSelect = (rating) => {
    setDetailedReview(prev => ({ ...prev, rating }));
  };

  const handleAspectToggle = (aspectId) => {
    setDetailedReview(prev => {
      const isSelected = prev.selectedAspects.includes(aspectId);
      if (isSelected) {
        return {
          ...prev,
          selectedAspects: prev.selectedAspects.filter(id => id !== aspectId)
        };
      } else {
        return {
          ...prev,
          selectedAspects: [...prev.selectedAspects, aspectId]
        };
      }
    });
  };

  const handleCommentChange = (e) => {
    setDetailedReview(prev => ({ ...prev, comment: e.target.value }));
  };

  const handleSubmitReview = async () => {
    if (detailedReview.rating === 0) {
      alert(t('reviewPage.alerts.ratingRequired'));
      return;
    }
    
    if (!user?.id) {
      alert('Для отправки отзыва необходимо авторизоваться');
      return;
    }
    
    setSubmitting(true);
    
    try {
      const reviewData = {
        user_id: user.id,
        rating: detailedReview.rating,
        comment: detailedReview.comment || ''
      };
      
      if (selectedService?.type === 'doctor') {
        reviewData.doctor_id = selectedService.data.id;
      } else if (selectedService?.id) {
        reviewData.service_id = selectedService.id;
      } else {
        alert('Ошибка: не выбран объект для оценки');
        setSubmitting(false);
        return;
      }
      
      const result = await api.addReview(reviewData);
      
      if (result) {
        alert('Спасибо за отзыв! Он будет опубликован после модерации.');
        // Возвращаемся на уровень выбора услуги
        setSelectedService(null);
        setDetailedReview({
          rating: 0,
          selectedAspects: [],
          comment: ''
        });
      } else {
        alert('Произошла ошибка при отправке отзыва');
      }
    } catch (error) {
      console.error('Ошибка отправки отзыва:', error);
      alert('Произошла ошибка при отправке отзыва');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCloseModal = () => {
    setSelectedService(null);
    setDetailedReview({
      rating: 0,
      selectedAspects: [],
      comment: ''
    });
  };

  const handleBackToCategories = () => {
    setSelectedCategory(null);
    setSelectedSubcategory(null);
    setSelectedService(null);
    setSubcategories([]);
    setServices([]);
  };

  const handleBackToSubcategories = () => {
    setSelectedSubcategory(null);
    setSelectedService(null);
    setServices([]);
  };

  const handleBackToServices = () => {
    setSelectedService(null);
  };

  // Функция для иконки категории
  const getIconForCategory = (categoryName) => {
    const icons = {
      'Лучевая диагностика': '/icons/phototherapy.png',
      'Лабораторная диагностика': '/icons/lab.png',
      'Check-up': '/icons/checkup.png',
      'Функциональная диагностика': '/icons/functional.png',
      'Дополнительно к медосмотру': '/icons/doctors.png'
    };
    return icons[categoryName] || '/icons/default.png';
  };

  if (loading) {
    return (
      <div className="review-page">
        <div className="review-header">
          <button className="service-btn back-btn" onClick={onBack}>
            <span className="btn-icon">←</span>
            <span className="btn-text">{t('reviewPage.back')}</span>
          </button>
        </div>
        <div className="loading-spinner" style={{ textAlign: 'center', padding: '40px', color: 'white' }}>
          Загрузка...
        </div>
      </div>
    );
  }

  // ============= ВЫБОР УСЛУГИ ДЛЯ ОЦЕНКИ (3 уровня) =============
  if (reviewType === 'services' && !selectedService) {
    // Уровень 1: выбор категории
    if (!selectedCategory) {
      return (
        <div className="review-page">
          <div className="review-header">
            <button className="service-btn back-btn" onClick={onBack}>
              <span className="btn-icon">←</span>
              <span className="btn-text">{t('reviewPage.back')}</span>
            </button>
          </div>

          <div className="rating-header">
            <h2>{t('reviewPage.title')}</h2>
            <p>{t('reviewPage.subtitle')}</p>
          </div>

          <div className="review-switcher">
            <button 
              className={`switcher-btn ${reviewType === 'services' ? 'active' : ''}`}
              onClick={() => setReviewType('services')}
            >
              <span className="switcher-text">{t('reviewPage.switcher.services')}</span>
            </button>
            <button 
              className={`switcher-btn ${reviewType === 'doctors' ? 'active' : ''}`}
              onClick={() => setReviewType('doctors')}
            >
              <span className="switcher-text">{t('reviewPage.switcher.doctors')}</span>
            </button>
          </div>

          <div className="services-list">
            <div className="section-divider">
              <h3>Выберите категорию услуг</h3>
            </div>
            <div className="services-grid">
              {categories.map((category) => (
                <div 
                  key={category.id} 
                  className="service-card"
                  onClick={() => handleCategorySelect(category)}
                >
                  <div className="service-icon">
                    <img src={getIconForCategory(category.name)} alt={category.name} width="40" height="40" />
                  </div>
                  <div className="service-info">
                    <h4 className="service-name">{category.name}</h4>
                    <div className="rate-button">Выбрать</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="review-footer">
            <p className="review-note">{t('reviewPage.footer.note')}</p>
          </div>
        </div>
      );
    }
    
    // Уровень 2: выбор подкатегории
    if (selectedCategory && !selectedSubcategory) {
      return (
        <div className="review-page">
          <div className="review-header">
            <button className="service-btn back-btn" onClick={handleBackToCategories}>
              <span className="btn-icon">←</span>
              <span className="btn-text">Назад к категориям</span>
            </button>
          </div>

          <div className="rating-header">
            <h2>{selectedCategory.name}</h2>
            <p>Выберите раздел для оценки</p>
          </div>

          <div className="services-list">
            <div className="section-divider">
              <h3>Разделы</h3>
            </div>
            <div className="services-grid">
              {subcategories.map((subcategory) => (
                <div 
                  key={subcategory.id} 
                  className="service-card"
                  onClick={() => handleSubcategorySelect(subcategory)}
                >
                  <div className="service-icon">
                    <img src="/icons/service-default.png" alt={subcategory.name} width="40" height="40" />
                  </div>
                  <div className="service-info">
                    <h4 className="service-name">{subcategory.name}</h4>
                    <div className="rate-button">Выбрать</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="review-footer">
            <p className="review-note">{t('reviewPage.footer.note')}</p>
          </div>
        </div>
      );
    }
    
    // Уровень 3: выбор конкретной услуги
    if (selectedCategory && selectedSubcategory && !selectedService) {
      return (
        <div className="review-page">
          <div className="review-header">
            <button className="service-btn back-btn" onClick={handleBackToSubcategories}>
              <span className="btn-icon">←</span>
              <span className="btn-text">Назад к разделам</span>
            </button>
          </div>

          <div className="rating-header">
            <h2>{selectedSubcategory.name}</h2>
            <p>Выберите услугу для оценки</p>
          </div>

          <div className="services-list">
            <div className="section-divider">
              <h3>Услуги</h3>
            </div>
            <div className="services-grid" style={{ gridTemplateColumns: '1fr' }}>
              {services.map((service) => (
                <div 
                  key={service.id} 
                  className="service-card"
                  onClick={() => handleServiceSelect(service)}
                >
                  <div className="service-icon">
                    {service.image_url ? (
                      <img src={service.image_url} alt={service.name} width="40" height="40" />
                    ) : (
                      <img src="/icons/service-default.png" alt={service.name} width="40" height="40" />
                    )}
                  </div>
                  <div className="service-info" style={{ flex: 1 }}>
                    <h4 className="service-name">{service.name}</h4>
                    <div className="service-price">{service.price} ₽</div>
                  </div>
                  <div className="rate-button">Оценить</div>
                </div>
              ))}
            </div>
          </div>

          <div className="review-footer">
            <p className="review-note">{t('reviewPage.footer.note')}</p>
          </div>
        </div>
      );
    }
  }

  // ============= ВЫБОР ВРАЧА =============
  if (reviewType === 'doctors' && !selectedService) {
    return (
      <div className="review-page">
        <div className="review-header">
          <button className="service-btn back-btn" onClick={onBack}>
            <span className="btn-icon">←</span>
            <span className="btn-text">{t('reviewPage.back')}</span>
          </button>
        </div>

        <div className="rating-header">
          <h2>{t('reviewPage.title')}</h2>
          <p>{t('reviewPage.subtitle')}</p>
        </div>

        <div className="review-switcher">
          <button 
            className={`switcher-btn ${reviewType === 'services' ? 'active' : ''}`}
            onClick={() => setReviewType('services')}
          >
            <span className="switcher-text">{t('reviewPage.switcher.services')}</span>
          </button>
          <button 
            className={`switcher-btn ${reviewType === 'doctors' ? 'active' : ''}`}
            onClick={() => setReviewType('doctors')}
          >
            <span className="switcher-text">{t('reviewPage.switcher.doctors')}</span>
          </button>
        </div>

        <div className="doctors-list">
          <div className="section-divider">
            <h3>{t('reviewPage.doctorList.title')}</h3>
          </div>
          <div className="doctors-grid">
            {doctors.map((doctor) => (
              <div 
                key={doctor.id} 
                className="doctor-card"
                onClick={() => handleRateDoctor(doctor)}
              >
                <div className="doctor-photo">
                  <img 
                    src={doctor.image_url} 
                    alt={doctor.name} 
                    className="doctor-photo-img" 
                    onError={(e) => { e.target.src = '/icons/doctor-default.png'; }}
                  />
                </div>
                <div className="doctor-info">
                  <h4 className="doctor-specialty">{doctor.specialty}</h4>
                  <p className="doctor-name">{doctor.name}</p>
                  {doctor.rating > 0 && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '5px', justifyContent: 'center' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                        {Array(Math.floor(doctor.rating)).fill().map((_, i) => <span key={i}>⭐</span>)}
                      </div>
                      <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.6)' }}>
                        ({doctor.reviews_count})
                      </span>
                    </div>
                  )}
                  <div className="rate-button">{t('reviewPage.doctorList.rateButton')}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="review-footer">
          <p className="review-note">{t('reviewPage.footer.note')}</p>
        </div>
      </div>
    );
  }

  // ============= МОДАЛЬНОЕ ОКНО ОЦЕНКИ =============
  if (selectedService) {
    const isDoctor = selectedService.type === 'doctor';
    const itemData = isDoctor ? selectedService.data : selectedService;
    
    return (
      <div className="detailed-rating-modal">
        <div className="detailed-modal-content">
          <div className="detailed-modal-header">
            <div className="modal-category">
              <div className="modal-icon">
                {isDoctor ? (
                  <img src={itemData.image_url} alt={itemData.name} className="doctor-photo-img" onError={(e) => { e.target.src = '/icons/doctor-default.png'; }} />
                ) : (
                  <img src={itemData.image_url || '/icons/service-default.png'} alt={itemData.name} width="40" height="40" />
                )}
              </div>
              <div className="modal-title">
                <h3>{isDoctor ? itemData.specialty : itemData.name}</h3>
                <p className="modal-subtitle">
                  {isDoctor ? itemData.name : t('reviewPage.modal.leaveRating')}
                </p>
              </div>
            </div>
            <button className="modal-close-btn" onClick={handleCloseModal}>✕</button>
          </div>

          <div className="detailed-rating-section">
            <h4>{t('reviewPage.modal.rateQuality')}</h4>
            <div className="detailed-rating-stars">
              {ratings.map((rating) => (
                <button
                  key={rating}
                  className={`detailed-star-btn ${detailedReview.rating >= rating ? 'active' : ''}`}
                  onClick={() => handleRatingSelect(rating)}
                >
                  <span className="star-icon">★</span>
                  <span className="star-number">{rating}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="aspects-section">
            <h4>{t('reviewPage.modal.whatLiked')}</h4>
            <div className="aspects-grid">
              {aspects.map((aspect) => (
                <button
                  key={aspect.id}
                  className={`aspect-btn ${detailedReview.selectedAspects.includes(aspect.id) ? 'selected' : ''}`}
                  onClick={() => handleAspectToggle(aspect.id)}
                >
                  <span className="aspect-icon">
                    <img src={aspect.icon} alt={aspect.name} width="20" height="20" />
                  </span>
                  <span className="aspect-name">{aspect.name}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="comment-section">
            <h4>{t('reviewPage.modal.shareExperience')}</h4>
            <textarea
              className="comment-input"
              placeholder={t('reviewPage.modal.commentPlaceholder')}
              value={detailedReview.comment}
              onChange={handleCommentChange}
              maxLength={500}
              rows={4}
            />
            <div className="comment-counter">
              {detailedReview.comment.length}/500 {t('reviewPage.modal.characters')}
            </div>
          </div>

          <div className="modal-actions">
            <button 
              className={`submit-review-btn ${detailedReview.rating === 0 || submitting ? 'disabled' : ''}`}
              onClick={handleSubmitReview}
              disabled={detailedReview.rating === 0 || submitting}
            >
              <span className="submit-text">{submitting ? 'Отправка...' : t('reviewPage.modal.submit')}</span>
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default ReviewPage;